import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 10 10" {...props}>
      <path d="M5 0C2.24219 0 0 2.24219 0 5C0 7.75781 2.24219 10 5 10C7.75781 10 10 7.75781 10 5C10 2.24219 7.75781 0 5 0ZM7.38281 5.2832L6.18359 6.48242C6.10547 6.55859 6.00391 6.59961 5.90039 6.59961C5.84766 6.59961 5.79688 6.58984 5.74609 6.57031C5.59766 6.50781 5.5 6.36133 5.5 6.19922V5.5H3C2.72461 5.5 2.5 5.27539 2.5 5C2.5 4.72461 2.72461 4.5 3 4.5H5.5V3.80078C5.5 3.63867 5.59766 3.49219 5.74609 3.42969C5.89648 3.36914 6.06836 3.40234 6.18359 3.51758L7.38281 4.7168C7.53906 4.87305 7.53906 5.12695 7.38281 5.2832Z" />
    </Svg>
  );
};

export default Icon;
